/* eslint-disable react-refresh/only-export-components */
import { AppsListRegular, Archive24Regular, Building24Regular, Settings24Regular } from '@fluentui/react-icons';
import Dashboard from '.';
import { useProject } from '../context/ProjectContext';
import type { AdminRouterItem } from '../router';
import NdaAgreement from './NdaAgreement';
import ProjectLayout from './ProjectLayout';
import Archive from './sections/Archive';
import Auswertungen from './sections/Auswertungen';
import Dokumente from './sections/Dokumente';
import Eckdaten from './sections/Eckdaten';
import EckdatenHistory from './sections/EckdatenHistory';
import EckdatenProjektpartner from './sections/EckdatenProjektpartner';
import EckdatenWebsite from './sections/EckdatenWebsite';
import Evaluations from './sections/Evaluations';
import Mitarbeiter from './sections/Mitarbeiter';
import Projektmanagement from './sections/Projektmanagement';
import Projektpartnerverwaltung from './sections/Projektpartnerverwaltung';
import Rechnungen from './sections/Rechnungen';
import RiskManagement from './sections/Riskmanagement';
import Settings from './sections/Settings';
import Teams from './sections/Teams';

// Wrapper components that use ProjectContext
const EckdatenProjektpartnerWrapper = () => {
    const { project } = useProject();
    return <EckdatenProjektpartner project={project} />;
};

const EckdatenWebsiteWrapper = () => {
    const { project } = useProject();
    return <EckdatenWebsite project={project} />;
};

const EckdatenHistoryWrapper = () => {
    const { project } = useProject();
    return <EckdatenHistory project={project} />;
};

const dashboardRoutes: AdminRouterItem[] = [
    {
        path: '',
        element: <Dashboard />,
        meta: {
            label: 'Dashboard',
            title: 'Dashboard',
            key: '/',
            icon: <AppsListRegular />,
        },
    },
    {
        path: 'projektpartnerverwaltung',
        element: <Projektpartnerverwaltung />,
        meta: {
            label: 'Project Partner Management',
            title: 'Project Partner Management',
            key: '/projektpartnerverwaltung',
            icon: <Building24Regular />,
        },
    },
    {
        path: 'auswertungen',
        element: <Auswertungen />,
        meta: {
            label: 'Reports',
            title: 'Reports',
            key: '/auswertungen',
            icon: <AppsListRegular />,
        }
    },
    {
        path: 'archive',
        element: <Archive />,
        meta: {
            label: 'Archive',
            title: 'Archive',
            key: '/archive',
            icon: <Archive24Regular />,
        },
    },
    {
        path: 'settings',
        element: <Settings />,
        meta: {
            label: 'Settings',
            title: 'Settings',
            key: '/settings',
            icon: <Settings24Regular />,
            allowedRoles: ['Administratoren', 'Forschungsservice'],
        },
    }
];

const projectRoutes: AdminRouterItem[] = [
    {
        path: 'project',
        element: <ProjectLayout />,
        meta: {
            label: 'Project',
            title: 'Project',
            key: '/project',
            hideInMenu: true,
        },
        children: [
            {
                path: ':id',
                element: <Eckdaten />,
                meta: {
                    label: 'Project Data',
                    title: 'Project Data',
                    key: '/project/:id',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/eckdaten',
                element: <Eckdaten />,
                meta: {
                    label: 'Project Data',
                    title: 'Project Data',
                    key: '/project/:id/eckdaten',
                },
            },
            {
                path: ':id/mitarbeiter',
                element: <Mitarbeiter />,
                meta: {
                    label: 'Project Team',
                    title: 'Project Team',
                    key: '/project/:id/mitarbeiter',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/eckdaten-partner',
                element: <EckdatenProjektpartnerWrapper />,
                meta: {
                    label: 'Project Partners',
                    title: 'Project Partners',
                    key: '/project/:id/eckdaten-partner',
                },
            },
            {
                path: ':id/eckdaten-website',
                element: <EckdatenWebsiteWrapper />,
                meta: {
                    label: 'Website',
                    title: 'Website',
                    key: '/project/:id/eckdaten-website',
                },
            },
            {
                path: ':id/eckdaten-history',
                element: <EckdatenHistoryWrapper />,
                meta: {
                    label: 'History',
                    title: 'History',
                    key: '/project/:id/eckdaten-history',
                },
            },
            {
                path: ':id/dokumente',
                element: <Dokumente />,
                meta: {
                    label: 'Documents',
                    title: 'Documents',
                    key: '/project/:id/dokumente',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/projektmanagement',
                element: <Projektmanagement />,
                meta: {
                    label: 'Project Management',
                    title: 'Project Management',
                    key: '/project/:id/projektmanagement',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/rechnungen',
                element: <Rechnungen />,
                meta: {
                    label: 'Invoices',
                    title: 'Invoices',
                    key: '/project/:id/rechnungen',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/riskmanagement',
                element: <RiskManagement />,
                meta: {
                    label: 'Risk Management',
                    title: 'Risk Management',
                    key: '/project/:id/riskmanagement',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/teams',
                element: <Teams />,
                meta: {
                    label: 'Teams',
                    title: 'Teams',
                    key: '/project/:id/teams',
                    hideInMenu: true,
                },
            },
            {
                path: ':id/evaluations',
                element: <Evaluations />,
                meta: {
                    label: 'Reports',
                    title: 'Reports',
                    key: '/project/:id/evaluations',
                    hideInMenu: true,
                },
            },
        ],
    }
];

// Standalone routes not shown in menu
const standaloneRoutes: AdminRouterItem[] = [
    {
        path: 'ndagreement',
        element: <NdaAgreement />,
    },
];

export default [...dashboardRoutes, ...projectRoutes, ...standaloneRoutes];
